import { SelectChangeEvent } from "@mui/material";
import React, { FC } from "react";
import { SingleFilter } from "./singleFilter";
import { extraFilters, getFilterProps } from "./helper";
import { IconProps, IconSettings } from "../../../../utils/icons";

interface Props {
  onFilterSelect: (key: string, id?: string) => void;
  queryFilters?: any;
}

const GearIcon = (props: IconProps) => <IconSettings {...props} color="none" />;

export const ExtraFilter: FC<Props> = ({ onFilterSelect, ...rest }) => (
  <SingleFilter
    {...rest}
    {...getFilterProps(extraFilters, "extraFilter")}
    updateSearch={onFilterSelect}
    icon={GearIcon}
  />
);
